// src/pages/ExperiencePage.tsx
import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  Chip,
} from '@mui/material';
import { getExperiences, Experience } from '../api/experienceService';

const ExperiencePage: React.FC = () => {
  const [experiences, setExperiences] = useState<Experience[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchExperiences = async () => {
      try {
        const data = await getExperiences();
        setExperiences(data);
      } catch (err) {
        console.error('Error fetching experiences:', err);
        setError('Failed to load experiences');
      } finally {
        setLoading(false);
      }
    };

    fetchExperiences();
  }, []);

  if (loading) return <Typography>Loading...</Typography>;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Container>
      <Typography variant="h4" component="h1" gutterBottom>
        Professional Experience
      </Typography>

      <Grid container spacing={3}>
        {experiences.map((exp) => (
          /* <Grid
            key={exp.id}
            {...{ item: true, xs: 12 }} // ✅ workaround to help TS resolve overload */
			<Grid key={exp.id} {...{ item: true, xs: 12 }}sx={{ mb: 3 }}
          >
            <Card>
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="flex-start"
                >
                  <Typography variant="h5">{exp.title}</Typography>
                  <Chip
                    label={
                      exp.is_current
                        ? 'Current'
                        : `${exp.date_start} - ${exp.date_end || ''}`
                    }
                    color={exp.is_current ? 'primary' : 'default'}
                  />
                </Box>
                <Typography variant="h6" color="textSecondary">
                  {exp.company} - {exp.location}
                </Typography>
                <Typography variant="body1" paragraph sx={{ mt: 2 }}>
                  {exp.description}
                </Typography>
                {exp.achievements && (
                  <>
                    <Typography variant="subtitle1" fontWeight="bold">
                      Key Achievements:
                    </Typography>
                    <Typography variant="body1">{exp.achievements}</Typography>
                  </>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ExperiencePage;
